import { useMutation } from "react-query";
import { UpdateAttachmentRequestParams, updateAttachment } from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const updateAttachmentFn = async (params: UpdateAttachmentRequestParams) => {
  return await updateAttachment(params);
};

export function useUpdateAttachment() {
  return useMutation(updateAttachmentFn, {
    mutationKey: MUTATION_KEYS.updateAttachment,
    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
